import React, { createContext, useContext } from 'react';
import { CountryCode } from 'shared/constants/countries';

import { useRegion } from '@/hooks/useRegion';

export type ContextValue = {
    isInvoicingAvailable: boolean;
    isInvoiceSystemEnabled: boolean;
};

export type Props = {
    children: React.ReactNode;
};

const InvoicingSystemContext = createContext<ContextValue>({
    isInvoicingAvailable: false,
    isInvoiceSystemEnabled: false,
});

const InvoicingSystemContextProvider = ({ children }: Props) => {
    const region = useRegion();

    const isUSRegion = region?.code === CountryCode.unitedStates;
    const isInvoiceSystemEnabled = isUSRegion;

    return (
        <InvoicingSystemContext.Provider
            value={{
                // Web Invoicing is gated by region only. The US is
                // invoicing-only on mobile, so it must stay hidden on web
                // regardless of any accounting provider record — a stale or
                // failed Xero/QBO connect must not unlock it. Mobile US
                // invoicing is separate
                // (mobile/src/hooks/useIsInvoiceSystemEnabled.tsx).
                isInvoicingAvailable: !isUSRegion,
                isInvoiceSystemEnabled,
            }}
        >
            {children}
        </InvoicingSystemContext.Provider>
    );
};

function useInvoicingSystemContext() {
    const context = useContext(InvoicingSystemContext);

    return context;
}

export { InvoicingSystemContextProvider, useInvoicingSystemContext };
